document.addEventListener('click', function(event) {
  if (event.target && event.target.id === 'shippingCheckbox') {
    if (event.target.checked) {
      console.log('Shipping checkbox checked');
    } else {
      console.log('Shipping checkbox unchecked');
    }
  }
});